/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-plusplus */
/* eslint-disable func-names */
import EDC from '../../../shared/globals';
import Rocket from '../rocket';
import store from '@/store/index';

/**
 *
 */
EDC.Games.ImagesToTextSpace.Scenes.Rockets = function () {
  const difficultyConfig = store.getters['gameConfig/getGameConfig'];
  const defaultDifficulty = store.getters['games/getGameById']().sets[0].config;
  if (difficultyConfig && difficultyConfig.gameCode === 16) {
    this.gameConfig = { ...defaultDifficulty, ...difficultyConfig.config };
    this.difficulty = difficultyConfig.difficulty;
  } else {
    this.gameConfig = defaultDifficulty;
  }

  this.difficulty = 1;
  this.signals = {
    S_ROCKET_AWAY: 'S_ROCKET_AWAY',
  };
  this.rocketsContainers = [];
  this.rocketsAway = 0;
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Scenes.Rockets.prototype.createAnimations = function () {
  const animsCfg = {
    rocketFlame: {
      key: 'rocketFlame',
      frames: this.anims.generateFrameNumbers('rocket-flame', { start: 0, end: 2, first: 0 }),
      frameRate: 6,
      repeat: -1,
    },
  };

  for (const anim in animsCfg) {
    const cfg = animsCfg[anim];
    this.anims.create(cfg);
  }
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Scenes.Rockets.prototype.create = function () {
  this.createAnimations();
  this.add.sprite(0, 0, 'background').setOrigin(0, 0);

  this.events.on(this.signals.S_ROCKET_AWAY, this.onRocketAway, this);

  const count = this.gameConfig.sets[this.difficulty].itemsCount;
  const slotWidth = this.game.scale.width / count;
  for (let i = 0; i < count; i++) {
    const rocket = new Rocket(this).create(slotWidth * i + slotWidth / 2, 650, 0);
    rocket.start();
  }
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Scenes.Rockets.prototype.onRocketAway = function () {
  this.rocketsAway++;
  if (this.rocketsAway >= this.gameConfig.sets[this.difficulty].itemsCount) {
    this.scene.start('main');
  }
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Scenes.Rockets.prototype.addRocket = function (x, y) {
  const rocketsCountTotal = 8;
  const container = this.add.container(x, y);
  const rndIndex = Math.floor(Math.random() * rocketsCountTotal);
  const rocket = this.add.sprite(0, 0, `rocket${rndIndex}`);
  container.add(rocket);
};

export default EDC.Games.ImagesToTextSpace.Scenes.Rockets;
